export default __webpack_public_path__ + "static/img1-6ec82d87da85076353b8bf0011987d58.png";